import React, { useEffect, FC, useContext, useState } from "react";
import Svg from "@natera/material/lib/svg";
import EmpowerImage from "@assets/svg/empower-risk-alert.svg";
import BookMarkStarSVG from "@assets/svg/icons/book-mark-star.svg";
import { InfoCard } from "@natera/patient";
import { defineMessages, useIntl } from "react-intl";
import { HEAP_EVENTS } from "@app/provider/types";
import { UserContext } from "@app/provider";
import { Button } from "@natera/form";
import { useDialog } from "@natera/platform/lib/hooks";
import EmpowerAlertDialog from "@app/components/empowerAlertDialog";
import EmpowerAlertPopUp from "@app/components/empowerAlertPopUp";

import "./empowerAlertBanner.scss";

const messages = defineMessages({
  empowerAlertBannerText: {
    id: "empowerAlertBannerText",
    defaultMessage: "You may qualify for hereditary cancer testing",
  },
  empowerAlertBannerLinkButton: {
    id: "empowerAlertBannerLinkButton",
    defaultMessage: "Learn more",
  },
});

export interface EmpowerAlertBannerProps {
  limsId?: number;
}

const EmpowerAlertBanner: FC<EmpowerAlertBannerProps> = ({ limsId }) => {
  const intl = useIntl();
  const { uppUser } = useContext(UserContext);

  const empowerAlertDialog = useDialog(EmpowerAlertDialog);
  const empowerAlertPopUpDialog = useDialog(EmpowerAlertPopUp);

  const [empowerAlertDialogWasClosed, setEmpowerAlertDialogWasClosed] =
    useState<boolean>(false);

  useEffect(() => {
    empowerAlertDialogWasClosed && openEmpowerAlertPopUp();
  }, [empowerAlertDialogWasClosed]);

  const openEmpowerAlertPopUp = () => {
    empowerAlertPopUpDialog.open({
      onCloseDialog: empowerAlertPopUpDialog.close,
      limsId: limsId,
    });
  };

  const closeEmpowerAlertDialog = () => {
    empowerAlertDialog.close();
    setEmpowerAlertDialogWasClosed(true);
  };

  const openEmpowerAlertDialog = () => {
    setEmpowerAlertDialogWasClosed(false);
    empowerAlertDialog.open({
      onCloseDialog: () => closeEmpowerAlertDialog(),
    });

    heap.track(HEAP_EVENTS.upp_empower_risk_alert_click, {
      identity: uppUser?.patientUID,
      lims_clinic_id: limsId,
    });
  };

  useEffect(() => {
    heap.track(HEAP_EVENTS.upp_empower_risk_alert_banner, {
      identity: uppUser?.patientUID,
      lims_clinic_id: limsId,
    });
  }, []);

  return (
    <>
      {empowerAlertDialog.getDialog()}
      {empowerAlertPopUpDialog.getDialog()}
      <InfoCard
        className={"block-info-card empower-banner"}
        icon={BookMarkStarSVG}
        contentAside={
          <Svg className="block-info-card__image" content={EmpowerImage} />
        }
      >
        <div className="empower-alert-banner">
          <div data-testid="card-title" className="empower-alert-banner__title">
            <b>{intl.formatMessage(messages.empowerAlertBannerText)}</b>
          </div>
          <Button
            outlined
            className="empower-alert-banner__link"
            onClick={openEmpowerAlertDialog}
            aria-label={intl.formatMessage(
              messages.empowerAlertBannerLinkButton
            )}
          >
            {intl.formatMessage(messages.empowerAlertBannerLinkButton)}
          </Button>
        </div>
      </InfoCard>
    </>
  );
};

export default EmpowerAlertBanner;
